// Find My Size - Simplified Version
// Uses metaobject data from product metafield

const FindMySize = {
    sizeChartData: [],
    
    // Initialize the size finder
    init: function() {
        this.loadSizeChartData();
        this.populateDropdowns();
        this.attachEventListeners();
    },
    
    // Load size chart data from the hidden script tag
    loadSizeChartData: function() {
        try {
            const dataScript = document.getElementById('size-chart-data');
            if (dataScript) {
                const data = JSON.parse(dataScript.textContent);
                this.sizeChartData = data.sizeChart || [];
                console.log('Size chart data loaded:', this.sizeChartData);
            }
        } catch (error) {
            console.error('Error loading size chart data:', error);
        }
    },
    
    // Populate dropdowns with measurement ranges
    populateDropdowns: function() {
        if (!this.sizeChartData || this.sizeChartData.length === 0) {
            console.warn('No size chart data available');
            return;
        }
        
        const bustSelect = document.getElementById('bust');
        const waistSelect = document.getElementById('waist');
        const hipSelect = document.getElementById('hip');
        
        // Clear existing options (except the first placeholder)
        [bustSelect, waistSelect, hipSelect].forEach(select => {
            while (select.options.length > 1) {
                select.remove(1);
            }
        });
        
        // Populate options from size chart data
        this.sizeChartData.forEach((item, index) => {
            // Bust options
            if (item.bust_min && item.bust_max) {
                const bustOption = document.createElement('option');
                bustOption.value = index;
                bustOption.textContent = `${item.bust_min}-${item.bust_max} in`;
                bustOption.dataset.size = item.size;
                bustSelect.appendChild(bustOption);
            }
            
            // Waist options
            if (item.waist_min && item.waist_max) {
                const waistOption = document.createElement('option');
                waistOption.value = index;
                waistOption.textContent = `${item.waist_min}-${item.waist_max} in`;
                waistOption.dataset.size = item.size;
                waistSelect.appendChild(waistOption);
            }
            
            // Hip options
            if (item.hip_min && item.hip_max) {
                const hipOption = document.createElement('option');
                hipOption.value = index;
                hipOption.textContent = `${item.hip_min}-${item.hip_max} in`;
                hipOption.dataset.size = item.size;
                hipSelect.appendChild(hipOption);
            }
        });
    },
    
    // Attach event listeners
    attachEventListeners: function() {
        const openButton = document.querySelector('#ProductPopup-find-my-size');
        const closeButton = document.querySelector('#ModalClose-find-my-size');
        const modal = document.getElementById('PopupModal-find-my-size');
        const submitButton = document.querySelector('#ff-select .button');
        const selects = document.querySelectorAll('#ff-select .select__select');
        
        // Open modal
        if (openButton) {
            openButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.openModal();
            });
        }
        
        // Close modal
        if (closeButton) {
            closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeModal();
            });
        }
        
        // Close modal when clicking outside
        if (modal) {
            modal.addEventListener('click', (e) => {
                if (e.target === modal) {
                    this.closeModal();
                }
            });
        }
        
        // Submit form
        if (submitButton) {
            submitButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.calculateSize();
            });
        }
        
        // Remove error on change
        selects.forEach(select => {
            select.addEventListener('change', () => {
                select.classList.remove('error');
            });
        });
        
        // Close modal with Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.closeModal();
            }
        });
    },
    
    // Calculate recommended size based on selections
    calculateSize: function() {
        const bustSelect = document.getElementById('bust');
        const waistSelect = document.getElementById('waist');
        const hipSelect = document.getElementById('hip');
        
        // Clear previous errors
        [bustSelect, waistSelect, hipSelect].forEach(select => {
            select.classList.remove('error');
        });
        
        // Collect selected sizes (only non-empty ones)
        const selectedSizes = [];
        
        if (bustSelect.value) {
            const bustSize = bustSelect.options[bustSelect.selectedIndex].dataset.size;
            if (bustSize) selectedSizes.push(bustSize);
        }
        
        if (waistSelect.value) {
            const waistSize = waistSelect.options[waistSelect.selectedIndex].dataset.size;
            if (waistSize) selectedSizes.push(waistSize);
        }
        
        if (hipSelect.value) {
            const hipSize = hipSelect.options[hipSelect.selectedIndex].dataset.size;
            if (hipSize) selectedSizes.push(hipSize);
        }
        
        // Validate - at least one measurement must be selected
        if (selectedSizes.length === 0) {
            [bustSelect, waistSelect, hipSelect].forEach(select => {
                select.classList.add('error');
            });
            this.showError('Please select at least one measurement');
            return;
        }
        
        // Find the most common size (mode)
        const recommendedSize = this.findMostCommonSize(selectedSizes);
        
        // Display result
        this.showResult(recommendedSize, selectedSizes.length);
    },
    
    // Find the most common size from the array
    findMostCommonSize: function(sizes) {
        const frequency = {};
        sizes.forEach(size => {
            frequency[size] = (frequency[size] || 0) + 1;
        });
        
        // Find size with highest frequency
        let maxFreq = 0;
        let mostCommon = sizes[0];
        
        for (const size in frequency) {
            if (frequency[size] > maxFreq) {
                maxFreq = frequency[size];
                mostCommon = size;
            }
        }
        
        // If all different, use the middle value
        if (maxFreq === 1) {
            const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '1X', '2X', '3X'];
            const indices = sizes.map(s => sizeOrder.indexOf(s)).filter(i => i !== -1);
            
            if (indices.length > 0) {
                const middleIndex = Math.floor(indices.reduce((a, b) => a + b, 0) / indices.length);
                return sizeOrder[middleIndex];
            }
        }
        
        return mostCommon;
    },
    
    // Show the recommended size result
    showResult: function(size) {
        const resultsWrapper = document.querySelector('#ff-results--wrapper');
        const optionsWrapper = document.querySelector('#ff-select--wrapper');
        const resultElement = document.querySelector('.ff-result');
        
        if (resultElement) {
            resultElement.textContent = size;
        }
        
        if (optionsWrapper) {
            optionsWrapper.style.display = 'none';
        }
        
        if (resultsWrapper) {
            resultsWrapper.style.display = 'block';
            resultsWrapper.classList.add('show');
        }
        
        // Auto-select size variant if available
        this.selectSizeVariant(size);
    },
    
    // Select the size variant on the product page
    selectSizeVariant: function(size) {
        const sizeInput = document.querySelector(`.variant-radio input[name="Size"][value="${size}"]`);
        if (sizeInput) {
            sizeInput.checked = true;
            sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    },
    
    // Open modal
    openModal: function() {
        const modal = document.getElementById('PopupModal-find-my-size');
        if (modal) {
            modal.classList.add('open');
            document.body.style.overflow = 'hidden';
        }
    },
    
    // Close modal
    closeModal: function() {
        const modal = document.getElementById('PopupModal-find-my-size');
        if (modal) {
            modal.classList.remove('open');
            document.body.style.overflow = '';
            this.resetForm();
        }
    },
    
    // Reset form to initial state
    resetForm: function() {
        const selects = document.querySelectorAll('#ff-select .select__select');
        const resultsWrapper = document.querySelector('#ff-results--wrapper');
        const optionsWrapper = document.querySelector('#ff-select--wrapper');
        
        selects.forEach(select => {
            select.value = '';
            select.classList.remove('error');
        });
        
        if (resultsWrapper) {
            resultsWrapper.style.display = 'none';
            resultsWrapper.classList.remove('show');
        }
        
        if (optionsWrapper) {
            optionsWrapper.style.display = 'block';
        }
    }
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => FindMySize.init());
} else {
    FindMySize.init();
}